import RewardRewardType from './RewardRewardType'

export default RewardRewardType
